import React from 'react'
import { useTranslation } from 'react-i18next'
import './index.css'

/*
	Značajka je objavljena i sekcija je opisuje kao dostupnu. Snimki zaslona
	iz aplikacije još nema u repou, pa sekcija i dalje stoji na ikonama; ako
	se snimke pripreme, mreža kartica je mjesto gdje idu.
*/

const IconSparkle: React.FC = () => (
	<svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="#AD8957" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
		<path d="M12 3l1.9 5.1L19 10l-5.1 1.9L12 17l-1.9-5.1L5 10l5.1-1.9L12 3z"/>
		<path d="M18.6 16.4l.6 1.7 1.7.6-1.7.6-.6 1.7-.6-1.7-1.7-.6 1.7-.6.6-1.7z"/>
	</svg>
)

const IconPhone: React.FC = () => (
	<svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="#AD8957" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
		<rect x="6" y="2" width="12" height="20" rx="2.5"/>
		<circle cx="12" cy="11" r="3"/>
		<path d="M10.6 19h2.8"/>
	</svg>
)

const IconGallery: React.FC = () => (
	<svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="#AD8957" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
		<rect x="3" y="7" width="14" height="13" rx="2"/>
		<path d="M7 4h12a2 2 0 0 1 2 2v11"/>
		<circle cx="7.8" cy="11.5" r="1.2"/>
		<path d="M3.4 17.2l3.6-3.1 2.9 2.4 2.6-2.1 4.5 4"/>
	</svg>
)

const FaceFilters: React.FC = () => {
	const { t } = useTranslation('home')

	const items = [
		{ Icon: IconSparkle, key: 'item1' },
		{ Icon: IconPhone, key: 'item2' },
		{ Icon: IconGallery, key: 'item3' }
	]

	return (
		<section id='face-filters' className='face-filters-section'>
			<div className='face-filters-header'>
				<span className='face-filters-badge'>{t('faceFilters.badge')}</span>
				<h2 className='face-filters-title'>{t('faceFilters.title')}</h2>
				<p className='face-filters-subtitle'>{t('faceFilters.subtitle')}</p>
			</div>

			<div className='face-filters-grid'>
				{items.map(({ Icon, key }) => (
					<div key={key} className='face-filter-card'>
						<div className='face-filter-icon'><Icon /></div>
						<h3 className='face-filter-card-title'>{t(`faceFilters.${key}.title`)}</h3>
						<p className='face-filter-card-text'>{t(`faceFilters.${key}.text`)}</p>
					</div>
				))}
			</div>

			<p className='face-filters-note'>{t('faceFilters.note')}</p>
		</section>
	)
}

export default FaceFilters
